// src/components/forms/fieldsConfig/categorieFields.js

// Champs pour la création d'une catégorie
export const categorieCreationFields = [
  { 
    name: 'name', 
    label: 'Nom de la catégorie', 
    type: 'text', 
    required: true,
    placeholder: 'Ex: Électronique, Mobilier, Fournitures...',
    validate: (value) => !value ? 'Le nom est obligatoire' : '',
    col: 12
  },
  { 
    name: 'description', 
    label: 'Description', 
    type: 'textarea', 
    rows: 3,
    placeholder: 'Description de la catégorie...',
    col: 12
  },
  { 
    name: 'parentId', 
    label: 'Catégorie parente', 
    type: 'select', 
    options: [], // Rempli dynamiquement
    placeholder: 'Sélectionner une catégorie parente (optionnel)',
    helpText: 'Laissez vide pour créer une catégorie racine',
    col: 12
  }
];

// Champs pour la mise à jour d'une catégorie
export const categorieUpdateFields = [...categorieCreationFields];

// Fonction pour formater les données catégorie
export const formatCategorieData = (formData) => {
  const formattedData = {
    name: formData.name?.trim(),
    description: formData.description?.trim()
  };

  // Gérer la catégorie parente
  if (formData.parentId) {
    formattedData.parentId = formData.parentId;
  } else {
    formattedData.parentId = null;
  }

  return formattedData;
};

// Fonction pour pré-remplir les données catégorie
export const prepareCategorieFormData = (categorie) => {
  if (!categorie) return {};
  
  return {
    name: categorie.name || '',
    description: categorie.description || '',
    parentId: categorie.parentId?._id || categorie.parentId || ''
  };
};

// Fonction de validation
export const validateCategorieForm = (formData) => {
  const errors = {};
  
  if (!formData.name?.trim()) {
    errors.name = 'Le nom de la catégorie est obligatoire';
  }
  
  return errors;
};

export default {
  creation: categorieCreationFields,
  update: categorieUpdateFields,
  format: formatCategorieData,
  prepare: prepareCategorieFormData,
  validate: validateCategorieForm
};